export enum Path {
    DASHBOARD = '/',
    LOGIN = '/login',
    USERS = '/users',
    BULK_MIGRATION = '/users/bulk-migration',
    PROGRAM_ACCESS_REPORT = '/users/program-access-report',
    PROGRAM_INFO = '/program-info',
    PROGRAM_EDIT = '/program-info/edit/:id',
    CATEGORIES = '/categories',
    EQUIPMENTS = '/equipments',
    EXERCISES = '/exercises',
    VIDEOS = '/videos',
    REST_DAYS = '/rest-days',
    WORKOUTS = '/workouts',
    RESOURCES = '/resources',
    HOMES = '/homes',
    WARMUPS = '/warmups',
    NEW_VERSION = '/modals/new-version',
    PROGRAM_INTROS = '/modals/program-intros',
    HOME_INTROS = '/modals/home-intros',
    END_PAGES = '/programs/end-pages',
}
